import { render, staticRenderFns } from "./OcrReport.vue?vue&type=template&id=b6c44a18&"
import script from "./OcrReport.vue?vue&type=script&lang=js&"
export * from "./OcrReport.vue?vue&type=script&lang=js&"
import style0 from "./OcrReport.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports